import { ButtonWithConfirmationDialogProps } from '../buttons.types';
import { Button } from '@mui/material';
import { DialogModal } from 'greener-ui-library';
import { useState } from 'react';

export function ButtonWithConfirmationDialog({
  handleConfirm,
  buttonText,
  confirmButtonText,
  cancelButtonText,
  variant = 'text',
  ButtonComponent = Button,
  children,
  buttonProps = {},
  dialogProps = {},
  title = '',
  color = 'tertiary',
  onClose = () => {},
  dialogConfirmButtonProps = {},
  startIcon,
}: ButtonWithConfirmationDialogProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <>
      <ButtonComponent
        data-testid="button-with-confirmation-dialog"
        variant={variant}
        color={color}
        onClick={handleOpen}
        startIcon={startIcon}
        {...buttonProps}
      >
        {buttonText}
      </ButtonComponent>
      <DialogModal
        isOpen={isOpen}
        closeModal={handleClose}
        title={title}
        confirmButtonText={confirmButtonText}
        confirmButtonProps={dialogConfirmButtonProps}
        cancelButtonText={cancelButtonText}
        dialogProps={dialogProps}
        children={children}
        handleConfirm={handleConfirm}
      />
    </>
  );
}
